import { render } from "./JourneyPlus.vue?vue&type=template&id=f872c3aa"
import script from "./JourneyPlus.vue?vue&type=script&lang=js"
export * from "./JourneyPlus.vue?vue&type=script&lang=js"
script.render = render

export default script